module.exports = __webpack_public_path__ + "static/media/shengdiao1.fef3f9d3.png";